import { render, staticRenderFns } from "./ChargerDetailsPopup.vue?vue&type=template&id=98836490"
import script from "./ChargerDetailsPopup.vue?vue&type=script&lang=js"
export * from "./ChargerDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./ChargerDetailsPopup.vue?vue&type=style&index=0&id=98836490&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports